import React from 'react';
import PropTypes from 'prop-types';
import { getImageUrl, AllImageSizes } from '@domain-group/fe-allhomes-library/lib/enums/image-size';
import ParentDevelopmentCoverPhoto from './parent-development-cover-photo';
import { jsx as ___EmotionJSX } from "@emotion/core";
var getHeroImage = (listing, development) => {
  var _listing$media;
  var firstVideo = (_listing$media = listing.media) === null || _listing$media === void 0 ? void 0 : _listing$media.firstVideo[0];
  return firstVideo ? firstVideo.imageSrc : development.coverImage;
};
var graphQLToProps = function graphQLToProps() {
  var _listing$media2, _listing$media2$first;
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$listing = _ref.listing,
    listing = _ref$listing === void 0 ? {} : _ref$listing,
    _ref$development = _ref.development,
    development = _ref$development === void 0 ? {} : _ref$development;
  return {
    heroImage: getImageUrl(getHeroImage(listing, development), AllImageSizes.COVER_SHOT),
    videoUrl: (_listing$media2 = listing.media) === null || _listing$media2 === void 0 ? void 0 : (_listing$media2$first = _listing$media2.firstVideo[0]) === null || _listing$media2$first === void 0 ? void 0 : _listing$media2$first.mediaSrc
  };
};
var ParentDevelopmentCoverPhotoGraphQL = _ref2 => {
  var property = _ref2.property;
  return ___EmotionJSX(ParentDevelopmentCoverPhoto, graphQLToProps(property));
};
ParentDevelopmentCoverPhotoGraphQL.propTypes = {
  property: PropTypes.shape({
    listing: PropTypes.shape({}),
    development: PropTypes.shape({})
  })
};
ParentDevelopmentCoverPhotoGraphQL.defaultProps = {
  property: {}
};
export default ParentDevelopmentCoverPhotoGraphQL;